module.exports = __webpack_public_path__ + "static/media/1990_Population_totalRate.6d028818.png";